module.exports = __webpack_public_path__ + "components/products_hero/images/release/item-promo02-a-08-0eaf41c8d85cde701a206f907be5571671a42ffb.png";